import { Grid, TextField } from '@mui/material';

import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { Grouping } from 'app/containers/AWPM-FWPM/ModuleSelections/models';
import { translations } from 'locales/i18n';

export function GroupingInformation() {
  const { t } = useTranslation();

  const { errors, touched } = useFormikContext<Grouping>();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Field
          as={TextField}
          name="name"
          error={touched.name && errors.name}
          helperText={touched.name && errors.name}
          fullWidth
          required
          label={t(translations.pages.groupings.modal.groupingName())}
        />
      </Grid>
      <Grid item xs={12}>
        <Field
          as={TextField}
          name="description"
          error={touched.description && errors.description}
          helperText={touched.description && errors.description}
          fullWidth
          label={t(translations.pages.groupings.modal.description())}
          multiline
          minRows={3}
          maxRows={3}
        />
      </Grid>
    </Grid>
  );
}
